import { addTraits } from 'src/api';

export const getAudits = state => addTraits(state.audits.audits);
export const getAudit = state => addTraits(state.audits.audit);
export const getCreateAudit = state => addTraits(state.audits.createAudit);
export const getUpdateAudit = state => addTraits(state.audits.updateAudit);
export const getDeleteAudit = state => addTraits(state.audits.deleteAudit);
export const getAuditHistory = state => addTraits(state.audits.auditHistory);